module.exports = __webpack_public_path__ + "static/media/galleryImg17.d8f29c9f.jpg";